import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  min-height: 23rem;
  padding: 3rem 5rem;
  width: 72.4rem;
  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 1000;
    margin-bottom: 0;
    text-align: center;
  }
`;

export const TextContainer = styled.div`
  margin-top: 3.2rem;
  h3 {
    color: rgba(46, 53, 61, 0.3);
    font-size: 12px;
    font-weight: bold;
  }
`;

interface ITextArea {
  hasError?: any;
  type?: any;
}
export const TextArea = styled.textarea<ITextArea>`
  ${(props) => `
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };  
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  border-radius: 0.8rem;
  box-shadow: 0px 5px 30px rgb(231 231 234 / 62%);
  font-size: 1.4rem;
  font-weight: 500;
  height: 17.7rem;
  padding: 2rem;
  resize: none;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const Button = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-top: 3rem;
  width: 32.4rem;
  .icon {
    height: 5rem;
    width: 5rem;
  }
`;
export const CharacterEnable = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: rgba(8, 8, 43, 0.4);
  display: flex;
  font-size: 1.2rem;
  justify-content: flex-end;
  margin-top: 0.9rem;
`;
